export { default as HotelTopStayDuration } from "./HotelTopStayDuration";
export { Top5PropertiesRoomsNightsResultSchema } from "./types";
export type { Top5PropertiesRoomsNightsResult } from "./types";
